import React from "react";
import Input from "../../../form/Input";
import Editor from "../../../form/Editor";
import FileUploadSingle from "../../../form/FileUploadSingle";

const HomeHiwForm = ({ values, handleChange, setFieldsValue }) => {
  const handleAddStep = () => {
    const updatedSteps = [
      ...(values.secondSubSection || []),
      { heading: "", description: "", image: "" },
    ];
    handleChange({ target: { name: "secondSubSection", value: updatedSteps } });
  };

  const handleRemoveStep = (index) => {
    const updatedSteps = values.secondSubSection?.filter((_, i) => i !== index);
    handleChange({ target: { name: "secondSubSection", value: updatedSteps } });
  };

  return (
    <div className="col-span-12 space-y-4">
      <h4 className="text-lg font-semibold">How It Works (Steps)</h4>

      <Editor
        label="Section Heading"
        value={values?.secondSubSectionHead?.heading || ""}
        onChange={(val) =>
          setFieldsValue({
            secondSubSectionHead: {
              ...values.secondSubSectionHead,
              heading: val,
            },
          })
        }
      />

      <Editor
        label="Section Description"
        value={values?.secondSubSectionHead?.description || ""}
        onChange={(val) =>
          setFieldsValue({
            secondSubSectionHead: {
              ...values.secondSubSectionHead,
              description: val,
            },
          })
        }
      />

      <div className="space-y-6">
        {(values?.secondSubSection || []).map((step, index) => (
          <div
            key={index}
            className="bg-white border rounded-2xl shadow-sm p-6 space-y-4 relative group"
          >
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 sm:col-span-4">
                <Input
                  label={`Step ${index + 1} Heading`}
                  value={step.heading}
                  inputPlaceholder="Enter step heading"
                  onChange={(e) => {
                    const updated = [...values.secondSubSection];
                    updated[index].heading = e.target.value;
                    setFieldsValue({ secondSubSection: updated });
                  }}
                />
              </div>
              <div className="col-span-12 sm:col-span-4">
                <Editor
                  label="Step Description"
                  value={step.description}
                  onChange={(val) => {
                    const updated = [...values.secondSubSection];
                    updated[index].description = val;
                    setFieldsValue({ secondSubSection: updated });
                  }}
                />
              </div>
              <div className="col-span-12 sm:col-span-3">
                <FileUploadSingle
                  label="Step Image"
                  value={step?.image}
                  onChange={(file) => {
                    const updated = [...values.secondSubSection];
                    updated[index].image = file;
                    setFieldsValue({ secondSubSection: updated });
                  }}
                  onRemove={() => {
                    const updated = [...values.secondSubSection];
                    updated[index].image = "";
                    setFieldsValue({ secondSubSection: updated });
                  }}
                />
              </div>
              <div className="col-span-12 sm:col-span-1 flex items-end justify-end">
                <button
                  type="button"
                  onClick={() => handleRemoveStep(index)}
                  className="text-sm text-red-600 hover:text-red-800 transition-colors"
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
        ))}

        <div className="pt-4">
          <button
            type="button"
            onClick={handleAddStep}
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-xl shadow transition-colors"
          >
            + Add Step
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomeHiwForm;
